<template>
    <div>
        <compare-snackbar
            v-model="snackbar.show"
            :search-request="transfersStore.searchRequest"
            :departure-point="transfersRuntimeStore.departurePoint"
            product-type="transfer"
            @close-comparison="toggleComparison"
        />
        <v-btn v-if="offers.length > 1" variant="text" block @click="toggleComparison">
            {{ compareMode ? $t('close_comparison') : $t('compare_transfers') }}
        </v-btn>
        <component
            :is="component"
            v-for="(product, index) in offers"
            :key="`${index}_${product.info.name}`"
            :product="product"
            :is-return-transfer="isReturnTransfer"
            :is-first="product === offers[0]"
            :compare-mode="compareMode"
            :data-cy="`transfer-offer-${index}`"
            :class="{
                'compare-selected':
                    compareMode &&
                    product.offers?.some(({offerKey}) => offersToCompareKeys?.find(key => key === offerKey)),
            }"
            class="my-2"
            @select-transfer-offer="selectTransferOffer"
        />
        <conditions-modal>
            <template v-slot:info>
                <transfer-conditions-modal-info />
            </template>
        </conditions-modal>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'
    import ConditionsModal from '@/components/modals/ConditionsModal.vue'
    import TransferConditionsModalInfo from '@/components/transfers/snippets/TransferConditionsModalInfo.vue'
    import TransferCard from '~src/components/transfers/search/offers/transferCard.src'
    import TransferCardMobile from '~/components/transfers/search/offers/TransferCardMobile.vue'
    import CompareSnackbar from '@/components/snippets/CompareSnackbar.vue'

    @Component({
        components: {
            CompareSnackbar,
            TransferConditionsModalInfo,
            ConditionsModal,
            TransferCard,
            TransferCardMobile,
        },
    })
    export class TransferOffers extends Vue {
        @Prop({default: () => []}) offers
        @Prop() isReturnTransfer

        /*get groupedOffers() {
            return transfersRuntimeStore.offers.reduce((groupedProducts, product) => {
                const groupedProductIndex = groupedProducts.findIndex(
                    groupedProduct => groupedProduct.name === product.info.name
                )
                if (groupedProductIndex === -1) {
                    groupedProducts.push({
                        name: product.info.name,
                        products: [product],
                    })
                } else {
                    groupedProducts[groupedProductIndex].products.push(product)
                }
                return groupedProducts
            }, [])
        }*/

        compareMode = false
        snackbar = {
            show: false,
        }

        @Emit()
        selectTransferOffer(offer) {
            return offer
        }

        toggleComparison() {
            this.snackbar.show = !this.snackbar.show
            this.compareMode = !this.compareMode

            if (!this.compareMode) transfersStore.CLEAR_OFFERS_TO_COMPARE()
        }

        get component() {
            return !this.$breakpoint.smAndDown
                ? resolveComponent('TransferCard')
                : resolveComponent('TransferCardMobile')
        }

        get offersToCompareKeys() {
            return transfersStore.offersToCompare.map(({offersKeys}) => offersKeys)?.flat()
        }
    }

    export default TransferOffers
</script>

<style scoped lang="scss">
    .compare-selected {
        border: 2px solid #1976d2;
        box-shadow:
            0 3px 1px -2px #1976d2,
            0px 2px 2px 0px #1976d2,
            0px 1px 5px 0px #1976d2;
    }
</style>
